import { LandingSeo } from './LandingSeo';
import { LandingExperienceBody } from './sections/LandingExperienceBody';

export function LandingPageExperience() {
  return (
    <>
      <LandingSeo />
      <LandingExperienceBody />
    </>
  );
}
